import uuid from "uuid/v4";
import { createModule } from "direct-vuex";
import { FormState, InputTypes } from "./types";
import { moduleActionContext } from "..";

const form = createModule({
  namespaced: true,
  state: (): FormState => {
    return {
      selected: {}
    };
  },
  mutations: {
    UPDATE_SELECTED(state, attrs: { [key: string]: InputTypes }) {
      state.selected = { ...state.selected, ...attrs };
    },
    CLEAR_SELECTED(state) {
      state.selected = {};
    }
  }
});

export default form;
export const formActionContext = (context: any) =>
  moduleActionContext(context, form);
